<template>
  <b-modal
    id="modal-buy-complete"
    class="custom-modal2"
    :hide-footer="true"
    modal-class="custom-modal2"
    content-class="rectangular-dark-blue-modal"
    @shown="onOpen"
    @hidden="onClose"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <a href="#" class="close-button" @click="close()"> </a>
      <div
        class="head-icon to-center-abs bg-img"
        :style="{
          backgroundImage:
            'url(' + $whitelabel.assets.features.shop.visual + ')',
        }"
      ></div>
    </template>

    <template
      v-if="lastBoughtItem && boughtItems && $store.state.shop.paymentCompleted"
      slot="default"
    >
      <div
        class="position-relative d-flex flex-column align-items-center pt-5 pb-3"
      >
        <div class="complete-icon"></div>

        <div class="headline pb-3">
          {{ $t("shop.complete.header") }}
        </div>

        <div
          v-if="packageName && !lastBoughtItem.customImg"
          class="package-image"
        >
          <div
            v-if="getMoreContentLabel(lastBoughtItem.package)"
            class="shop-more-percent"
          >
            {{ getMoreContentLabel(lastBoughtItem.package).value }}
          </div>
          <img
            draggable="false"
            :src="getImageSrc(lastBoughtItem.package.slug)"
            class="h-100"
          />
        </div>

        <div v-else class="package-image">
          <div
            v-if="getMoreContentLabel(lastBoughtItem.package)"
            class="shop-more-percent"
          >
            {{ getMoreContentLabel(lastBoughtItem.package).value }}
          </div>
          <img
            draggable="false"
            :src="getImageSrc(lastBoughtItem.customImg)"
            class="h-100"
          />
        </div>

        <div
          v-if="packageName"
          class="package-name glow bold text-uppercase text-center pb-3"
        >
          {{ packageName }}
        </div>
        <div v-else class="package-name glow bold text-uppercase text-center">
          {{ $t("header.offer") }}
        </div>
        <div
          v-for="(currency, index) in mainCurrencies"
          :key="index"
          class="package-amount glow w-100 bold text-center relative d-inline-flex align-items-center justify-content-center"
        >
          <div :key="index">
            {{ formatNumber(shopChosenPackage.rewards[currency]) }}
            x

            <BaseAsset
              :asset="getAsset(currency)"
              class="ms-1"
              size="big"
            ></BaseAsset>
          </div>
        </div>

        <div class="glow-box glowing-border">
          <div class="package-bonus-text glow">
            {{ $t(`shop.header.bonus`) }}
          </div>
          <div v-if="boughtItems" class="package-bonus-icons">
            <b-row align-v="center" class="m-0">
              <b-col
                v-for="(bonusReward, index) in bonusRewardsArray"
                :key="bonusReward.amount + index"
                :class="`package-bonus-icon-${bonusReward.type}`"
                class="d-inline-flex align-items-center justify-content-center"
              >
                <div class="text">
                  <template v-if="bonusReward.type !== 'expbooster'">
                    {{ lastBoughtItem.rewards[bonusReward.type] }}x
                  </template>
                  <template v-else>
                    {{ Math.round(lastBoughtItem.rewards.expbooster / 60) }}
                    Min.</template
                  >
                </div>
                <BaseAsset
                  class="icon ms-1"
                  :asset="getAsset(bonusReward.type)"
                ></BaseAsset>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="!$store.state.shop.paymentCompleted">
      <div
        class="w-75 position-relative h-100 mx-auto p-5 d-flex align-items-center justify-content-center flex-column"
      >
        <div class="medium mt-5">
          {{ statusText }}
        </div>
        <div
          v-if="!paymentStatus || paymentStatus === 'Authorised'"
          class="w-100 position-relative"
          style="height: 175px"
        >
          <Spinner class="dead-center" />
        </div></div
    ></template>
  </b-modal>
</template>

<script>
import paymentFunctions from "@/mixins/paymentFunctions.js";
import i18next from "i18next";
import adyenMixin from "@/mixins/adyen.js";
import Spinner from "@/components/animation/animation-spinner.vue";
import { AdyenCheckout } from "@adyen/adyen-web/auto";
import BaseAsset from "../base/base-asset.vue";

export default {
  name: "ModalBuyComplete",
  components: { BaseAsset, Spinner },
  mixins: [paymentFunctions, adyenMixin],
  data() {
    return {
      packageName: null,
    };
  },

  computed: {
    boughtItems() {
      return this.lastBoughtItem.rewards;
    },
    lastBoughtItem() {
      return this.$store.getters["shop/getShopChosenPackage"];
    },
    paymentStatus() {
      return this.$store.state.shop.paymentStatus;
    },
    statusText() {
      if (!this.$store.state.shop.paymentStatus) {
        return "";
      }
      return this.$t(`payment.status.${this.$store.state.shop.paymentStatus}`);
    },
  },

  methods: {
    async onOpen() {
      if (!this.$store.state.shop.paymentProcessing) {
        this.setPackageName();
      }
      let sessionId;
      if (this.$store.getters["shop/getShowBuyResult"]) {
        sessionId = this.$store.state.shop.sessionId;
      } else {
        sessionId = this.$store.state.shop.adyenData.id;
      }
      let config = this.initializeAdyenConfig(
        this.$store.state.shop.adyenData,
        sessionId
      );
      const checkout = await AdyenCheckout(config);
      if (this.$store.getters["shop/getShowBuyResult"]) {
        checkout.submitDetails({
          details: { redirectResult: this.$store.state.shop.redirectResult },
        });
      }
      this.$store.dispatch("user/updateUser");
    },
    onClose() {
      if (
        this.$store.state.shop.paymentCompleted ||
        this.$store.state.shop.paymentError
      ) {
        this.$store.commit("shop/clearLastPayment");
      }
      this.$store.commit("setIsPageLoading", false);
      this.$bvModal.hide("modal-offer-ab-testing");
    },

    setPackageName() {
      if (this.lastBoughtItem && this.lastBoughtItem.customName) {
        this.packageName = this.lastBoughtItem.customName;
        return;
      }

      if (i18next.exists(`shop.items.${this.lastBoughtItem.package.slug}`)) {
        this.packageName = this.$t(
          `shop.items.${this.lastBoughtItem.package.slug}`
        );
        return;
      }

      this.packageName = null;
    },
    getImageSrc: function (slug) {
      try {
        return require("@/assets/img/shop/" + slug + ".png");
      } catch (e) {
        console.log(e);
        return "";
      }
    },
  },
};
</script>
<style lang="scss">
$modal-width: 530px;
$modal-height: 618px;

#modal-buy-complete {
  .modal-header {
    .head-icon {
      top: -95px;

      width: 480px;
      height: 182px;
    }
  }
  .modal-dialog {
    top: 100px;
    max-width: $modal-width;
    height: auto;
  }

  .modal-content {
    width: $modal-width;
    box-shadow: 0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 13px $text-shadow--cyan, 0 0 13px $text-shadow--cyan,
      0 0 6px rgba(0, 94, 110, 0.8), 0 0 6px rgba(0, 94, 110, 0.8);
    border: 2px solid white;
    border-radius: 16px;
  }
}
</style>

<style scoped lang="scss">
#modal-buy-complete {
  .glow {
    text-shadow: 0 0 16px $text-shadow--cyan, 0 0 8px $text-shadow--cyan,
      0 0 8px $text-shadow--cyan, 0 0 4px rgba(0, 94, 110, 0.8),
      0 0 4px rgba(0, 94, 110, 0.8);
  }

  .glowing-border {
    box-shadow: 0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 26px $text-shadow--cyan, 0 0 26px $text-shadow--cyan,
      0 0 13px $text-shadow--cyan, 0 0 13px $text-shadow--cyan,
      0 0 6px rgba(0, 94, 110, 0.8), 0 0 6px rgba(0, 94, 110, 0.8) !important;
  }

  .complete-icon {
    background: url(~@/assets/img/shop/icn-shop-buy-success.png) center/100%
      100% no-repeat;
    width: 50px;
    height: 50px;
  }

  .shop-more-percent {
    top: 0;
    right: 0;
    z-index: 1;
    position: absolute;
  }

  .headline {
    font-family: Ubuntu-Bold;
    font-size: 36px;
    text-transform: uppercase;
    color: #43ff00;
  }

  .package-image {
    height: 82px;
    position: relative;
  }

  .package-name {
    font-size: 36px;
  }

  .package-amount {
    font-family: Ubuntu-Bold;
    font-size: 48px;
    position: relative;
    display: inline-flex;
    text-align: center;
    line-height: 0.7;
    padding: 3rem 0 2rem 0;
  }

  .glow-box {
    border: 2px solid white;
    border-radius: 16px;
    width: 370px;
    height: 104px;

    .package-bonus-text {
      font-size: 21px;
      margin-top: 10px;
    }

    .icon {
      filter: drop-shadow(0 2px 12px $primary-accent);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
